var e = {
  "discover-more": "Discover More",
  "kaseya-one": "KaseyaOne",
  "my-it-complete": "My IT Complete"
};
export { e as default };